<div
  class="controlchat-fab"
  *ngIf="canView && userId"
  [class.has-unread]="hasUnreadMessages"
  (click)="toggleOpen()"
>
  <mat-icon>{{ isOpen ? 'close' : 'chat' }}</mat-icon>
</div>

<div class="controlchat-backdrop" *ngIf="isOpen" (click)="closePanel()"></div>

<aside class="controlchat-panel" *ngIf="isOpen">
  <header class="panel-header">
    <div class="panel-title">
      <h3>ControlChat</h3>
      <button type="button" class="icon" (click)="toggleHeaderMenu()" title="Menu">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
    <button type="button" class="icon" (click)="closePanel()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="panel-body">
    <div class="panel-menu" *ngIf="isHeaderMenuOpen">
      <div class="panel-menu-header">
        <button type="button" class="icon-button" (click)="headerMenuView === 'root' ? closeHeaderMenu() : backHeaderMenu()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <span *ngIf="headerMenuView === 'root'">Menu</span>
        <span *ngIf="headerMenuView === 'create-group'">Novo grupo</span>
        <span *ngIf="headerMenuView === 'keywords'">Gerenciar palavras</span>
      </div>
      <div class="panel-menu-actions" *ngIf="headerMenuView === 'root'">
        <button type="button" class="menu-action" *ngIf="!isRestrictedProfile && canCreate" (click)="openCreateGroupFromMenu()">
          Criar grupo
        </button>
        <button type="button" class="menu-action" *ngIf="!isRestrictedProfile && canManage" (click)="openKeywordsFromMenu()">
          Gerenciar palavras
        </button>
        <div class="menu-toggle">
          <mat-slide-toggle [(ngModel)]="soundEnabled" (change)="onSoundToggle($event.checked)">
            Aviso sonoro
          </mat-slide-toggle>
        </div>
      </div>
      <div class="panel-menu-content" *ngIf="headerMenuView === 'create-group'">
        <div class="group-form" *ngIf="isCreatingGroup" #groupForm>
          <input
            type="text"
            placeholder="Nome do grupo"
            [(ngModel)]="groupName"
          >
          <div class="group-member-search">
            <mat-icon>person_add</mat-icon>
            <input
              type="text"
              placeholder="Adicionar integrante"
              [(ngModel)]="groupMemberQuery"
              (input)="onGroupMemberSearch()"
            >
          </div>
          <div class="member-results" *ngIf="groupMemberResults.length">
            <button
              type="button"
              class="member-row"
              *ngFor="let user of groupMemberResults"
              (click)="addGroupMember(user)"
            >
              <span class="status-dot" [class.online]="user.online" [class.offline]="!user.online"></span>
              <div class="user-avatar" [class.has-photo]="getUserAvatarUrl(user)">
                <ng-container *ngIf="getUserAvatarUrl(user) as avatarUrl; else groupMemberInitialMenu">
                  <img [src]="avatarUrl" [alt]="'Foto de ' + (user.name || 'Usuário')">
                </ng-container>
                <ng-template #groupMemberInitialMenu>
                  {{ (user.name || 'U').charAt(0).toUpperCase() }}
                </ng-template>
              </div>
              <div class="user-info">
                <strong>{{ formatUserName(user.name) }}</strong>
                <small>{{ user.email }}</small>
              </div>
            </button>
          </div>
          <div class="member-selected" *ngIf="groupMembers.length">
            <div class="member-chip" *ngFor="let member of groupMembers">
              <span>{{ formatUserName(member.name) }}</span>
              <button type="button" (click)="removeDraftGroupMember(member)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
          <button
            type="button"
            class="group-submit"
            (click)="submitGroup()"
            [disabled]="!groupName.trim() || groupMembers.length === 0"
          >Criar grupo</button>
        </div>
      </div>
      <div class="panel-menu-content" *ngIf="headerMenuView === 'keywords'">
        <div class="section" *ngIf="canManage" #monitoringSection>
          <div class="section-header">
            <span>Monitoramento</span>
          </div>
          <div class="keyword-input">
            <input type="text" placeholder="Adicionar palavra-chave" [(ngModel)]="keywordInput">
            <button type="button" (click)="addKeyword()">Adicionar</button>
          </div>
          <div class="keyword-list">
            <div class="keyword-row" *ngFor="let keyword of keywords">
              <span>{{ keyword.phrase }}</span>
              <button type="button" (click)="removeKeyword(keyword.id)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
          <div class="monitoring-list">
            <div class="monitoring-item" *ngFor="let hit of monitoringHits">
              <strong>{{ hit.keyword_phrase }}</strong>
              <small>{{ hit.user_name }} · {{ hit.created_at | date:'short' }}</small>
              <span>{{ hit.message_text }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-left">
      <div class="search-box" *ngIf="!isRestrictedProfile">
        <mat-icon>search</mat-icon>
        <input type="text" placeholder="Pesquisar usuários" [(ngModel)]="searchTerm" (input)="onSearchChange()">
        <button type="button" class="search-clear" *ngIf="searchTerm.trim().length" (click)="clearSearch()" title="Limpar">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="section user-section">
        <div class="user-list" *ngIf="searchTerm.trim().length">
          <div class="user-row" *ngFor="let user of users" (click)="selectUser(user)">
            <div class="user-row-main">
              <span class="status-dot" [class.online]="user.online" [class.offline]="!user.online"></span>
              <div class="user-avatar" [class.has-photo]="getUserAvatarUrl(user)">
                <ng-container *ngIf="getUserAvatarUrl(user) as avatarUrl; else userInitial">
                  <img [src]="avatarUrl" [alt]="'Foto de ' + (user.name || 'Usuário')">
                </ng-container>
                <ng-template #userInitial>
                  {{ (user.name || 'U').charAt(0).toUpperCase() }}
                </ng-template>
              </div>
              <div class="user-info">
                <strong class="truncate">{{ formatUserName(user.name) }}</strong>
                <small class="truncate">{{ user.email }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section" *ngIf="!isRestrictedProfile">
        <div class="section-header">
          <span>Chats recentes</span>
        </div>
        <div class="chat-list">
          <ng-container *ngFor="let conv of conversations">
            <div
              class="chat-row"
              *ngIf="conv.type === 'DIRECT'"
              [class.unread]="isConversationUnread(conv.id)"
              [class.last-incoming]="conv.id === lastIncomingConversationId"
              (click)="openConversation(conv)"
            >
              <div class="chat-row-main">
                <span
                  class="status-dot"
                  [class.online]="isUserOnline(conv.other_user_id)"
                  [class.offline]="!isUserOnline(conv.other_user_id)"
                ></span>
                <div class="user-avatar chat-avatar" [class.has-photo]="getConversationAvatarUrl(conv)">
                  <ng-container *ngIf="getConversationAvatarUrl(conv) as avatarUrl; else chatInitial">
                    <img [src]="avatarUrl" [alt]="'Foto de ' + (conv.other_user_name || 'Usuário')">
                  </ng-container>
                  <ng-template #chatInitial>
                    {{ (conv.other_user_name || 'U').charAt(0).toUpperCase() }}
                  </ng-template>
                </div>
                <div class="chat-row-info">
                  <strong class="truncate">{{ conv.other_user_name }}</strong>
                  <small class="chat-preview truncate" *ngIf="getConversationPreview(conv)">
                    {{ getConversationPreview(conv) }}
                  </small>
                </div>
              </div>
              <div class="chat-row-time">{{ formatConversationTime(conv.last_message_at) }}</div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="section">
        <div class="section-header">
          <span>Grupos</span>
        </div>
        <div class="chat-list">
          <ng-container *ngFor="let conv of conversations">
            <div
              class="chat-row"
              *ngIf="conv.type === 'GROUP'"
              [class.unread]="isConversationUnread(conv.id)"
              [class.last-incoming]="conv.id === lastIncomingConversationId"
              (click)="openConversation(conv)"
            >
              <div class="chat-row-main">
                <span class="status-dot online"></span>
                <div class="user-avatar chat-avatar group-avatar">
                  {{ (conv.group_name || 'G').charAt(0).toUpperCase() }}
                </div>
                <div class="chat-row-info">
                  <strong class="truncate">{{ conv.group_name }}</strong>
                  <small class="chat-preview truncate" *ngIf="getConversationPreview(conv)">
                    {{ getConversationPreview(conv) }}
                  </small>
                </div>
              </div>
              <div class="chat-row-time">
                {{ formatConversationTime(conv.last_activity_at || conv.last_message_at) }}
              </div>
            </div>
          </ng-container>
        </div>
      </div>

    </div>

    <div class="panel-right">
      <div class="chat-header" *ngIf="selectedConversation">
        <div class="chat-header-title">
          <span
            class="status-dot"
            *ngIf="selectedConversation.type === 'DIRECT'"
            [class.online]="isUserOnline(selectedConversation.other_user_id)"
            [class.offline]="!isUserOnline(selectedConversation.other_user_id)"
          ></span>
          <div class="user-avatar chat-avatar header-avatar">
            <ng-container *ngIf="selectedConversation.type === 'DIRECT' && getConversationAvatarUrl(selectedConversation) as avatarUrl; else headerInitial">
              <img [src]="avatarUrl" [alt]="'Foto de ' + (selectedConversation.other_user_name || 'Usuário')">
            </ng-container>
            <ng-template #headerInitial>
              {{
                (
                  selectedConversation.type === 'GROUP'
                    ? (selectedConversation.group_name || 'G')
                    : (selectedConversation.other_user_name || 'U')
                ).charAt(0).toUpperCase()
              }}
            </ng-template>
          </div>
          <div class="chat-header-text">
            <strong class="truncate">
              {{ selectedConversation.type === 'GROUP' ? selectedConversation.group_name : selectedConversation.other_user_name }}
            </strong>
            <small class="truncate" *ngIf="selectedConversation.type === 'DIRECT'">{{ selectedConversation.other_user_email }}</small>
            <small class="chat-subtitle" *ngIf="selectedConversation.type === 'GROUP'">
              {{ selectedConversation.members_count || 0 }} participantes
            </small>
          </div>
        </div>
        <div class="chat-header-tools">
          <button
            type="button"
            class="icon-button"
            title="Pesquisar na conversa"
            (click)="toggleMessageSearch()"
          >
            <mat-icon>search</mat-icon>
          </button>
          <button
            type="button"
            class="icon-button"
            *ngIf="selectedConversation.type === 'GROUP'"
            title="Configurações do grupo"
            (click)="toggleGroupSettings()"
          >
            <mat-icon>settings</mat-icon>
          </button>
          <div class="chat-header-actions" *ngIf="selectedConversation.type === 'GROUP'">
            <button
              type="button"
              class="icon-button"
              title="Listar integrantes"
            (click)="toggleGroupPanel()"
          >
            <mat-icon>group</mat-icon>
          </button>
          <button
            type="button"
            class="icon-button"
            title="Adicionar integrante"
            (click)="toggleGroupAddMode()"
          >
            <mat-icon>person_add</mat-icon>
          </button>
          <button
            type="button"
            class="icon-button danger"
            title="Excluir grupo"
            *ngIf="canDeleteSelectedGroup()"
            (click)="deleteSelectedGroup()"
          >
            <mat-icon>delete</mat-icon>
          </button>
          </div>
        </div>
      </div>

      <div class="group-settings" *ngIf="selectedConversation?.type === 'GROUP' && showGroupSettings">
        <mat-slide-toggle
          [(ngModel)]="groupOnlyAdmins"
          (change)="onGroupOnlyAdminsChange($event.checked)"
          [disabled]="!isGroupAdminOrOwner()"
        >
          Somente administradores enviam mensagem
        </mat-slide-toggle>
      </div>

      <div class="chat-search" *ngIf="selectedConversation" [class.visible]="showMessageSearch">
        <mat-icon>search</mat-icon>
        <input
          type="text"
          placeholder="Pesquisar na conversa"
          [(ngModel)]="messageSearchTerm"
          (input)="onMessageSearchChange()"
          #messageSearchInput
        >
        <div class="search-meta">
          <span>{{ messageMatchLabel }}</span>
          <button type="button" class="icon-button" [disabled]="!messageMatchCount" (click)="goToPrevMatch()">
            <mat-icon>keyboard_arrow_up</mat-icon>
          </button>
          <button type="button" class="icon-button" [disabled]="!messageMatchCount" (click)="goToNextMatch()">
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
        </div>
      </div>

      <div class="group-member-panel" *ngIf="selectedConversation?.type === 'GROUP' && isGroupPanelOpen">
        <div class="group-member-search">
          <mat-icon>{{ isGroupAddMode ? 'person_add' : 'search' }}</mat-icon>
          <input
            type="text"
            [placeholder]="isGroupAddMode ? 'Buscar integrante para adicionar' : 'Pesquisar integrante do grupo'"
            [(ngModel)]="groupMemberFilter"
            (input)="onGroupMemberFilterChange()"
          >
        </div>
        <div class="member-list" *ngIf="!isGroupAddMode && filteredGroupMembers.length">
          <div class="member-row full" *ngFor="let member of filteredGroupMembers">
            <div class="member-info">
              <span class="member-name">
                {{ formatUserName(member.name) }}{{ isMemberAdmin(member) ? ' (Admin)' : '' }}
              </span>
              <small class="member-email">{{ member.email }}</small>
            </div>
            <div class="member-actions">
              <button
                type="button"
                class="member-role-toggle"
                *ngIf="canToggleMemberRole(member)"
                (click)="toggleMemberAdmin(member)"
              >
                {{ member.role === 'ADMIN' ? 'Remover admin' : 'Tornar admin' }}
              </button>
              <button
                type="button"
                class="member-remove"
                *ngIf="canRemoveMember(member)"
                (click)="removeGroupMember(member)"
              >
                Excluir
              </button>
            </div>
          </div>
        </div>
        <div class="member-results" *ngIf="isGroupAddMode && groupMemberSearchResults.length">
          <button
            type="button"
            class="member-row"
            *ngFor="let user of groupMemberSearchResults"
            (click)="addMemberToSelectedGroup(user)"
          >
            <span class="status-dot" [class.online]="user.online" [class.offline]="!user.online"></span>
            <div class="user-avatar" [class.has-photo]="getUserAvatarUrl(user)">
              <ng-container *ngIf="getUserAvatarUrl(user) as avatarUrl; else groupAddMemberInitial">
                <img [src]="avatarUrl" [alt]="'Foto de ' + (user.name || 'Usuário')">
              </ng-container>
              <ng-template #groupAddMemberInitial>
                {{ (user.name || 'U').charAt(0).toUpperCase() }}
              </ng-template>
            </div>
            <div class="user-info">
              <strong>{{ formatUserName(user.name) }}</strong>
              <small>{{ user.email }}</small>
            </div>
          </button>
        </div>
      </div>

      <div class="chat-empty" *ngIf="!selectedConversation">
        <mat-icon>chat</mat-icon>
        <p>Selecione um usuário ou conversa para iniciar.</p>
      </div>

      <div class="chat-messages" *ngIf="selectedConversation" #messagesContainer (click)="closeEmojiPicker()" (scroll)="onMessagesScroll()">
        <div
          class="chat-message-row"
          *ngFor="let msg of filteredMessages; trackBy: trackMessage"
          [class.own]="userId && msg.sender_id === userId"
          [class.match]="isMessageMatch(msg)"
          [class.match-active]="isActiveMessageMatch(msg)"
          [class.actions-open]="reactionPickerMessageId === msg.id"
          [attr.id]="'msg-' + msg.id"
        >
          <div class="message-avatar" *ngIf="userId && msg.sender_id !== userId">
            <ng-container *ngIf="getMessageAvatarUrl(msg) as avatarUrl; else messageInitial">
              <img [src]="avatarUrl" [alt]="'Foto de ' + (msg.sender_name || 'Usuário')">
            </ng-container>
            <ng-template #messageInitial>
              {{ (msg.sender_name || 'U').charAt(0).toUpperCase() }}
            </ng-template>
          </div>
          <div
            class="chat-message"
            [class.own]="userId && msg.sender_id === userId"
          >
            <div class="message-meta">
              <strong>{{ msg.sender_name || 'Usuário' }}</strong>
              <span class="meta-sep">·</span>
              <small>{{ msg.created_at | date:'short' }}</small>
            </div>
            <div class="reply-preview" *ngIf="msg.reply_to_message_id">
              <small>{{ msg.reply_sender_name || 'Usuário' }}</small>
              <div class="reply-text" [innerHTML]="getReplyPreviewHtml(msg)"></div>
            </div>
            <button
              type="button"
              class="image-open image-card"
              *ngIf="msg.file_path && isImageUrl(msg.file_path)"
              (click)="openImageModal(msg.file_path)"
            >
              <img [src]="msg.file_path" [alt]="msg.file_name || 'Anexo'">
            </button>
            <div class="audio-card" *ngIf="msg.file_path && isAudioUrl(msg.file_path)">
              <audio [src]="msg.file_path" controls></audio>
            </div>
            <div class="message-body" *ngIf="msg.message_text" [innerHTML]="getHighlightedMessage(msg)"></div>
            <a
              class="file-card"
              *ngIf="msg.file_path && !isImageUrl(msg.file_path) && !isAudioUrl(msg.file_path)"
              [href]="msg.file_path"
              target="_blank"
            >
              <span class="file-icon">{{ fileExtLabel(msg.file_name) }}</span>
              <span class="file-meta">
                <strong class="file-name">{{ truncateFileName(msg.file_name || 'Arquivo') }}</strong>
                <small class="file-ext">{{ fileExtLabel(msg.file_name) }}</small>
              </span>
            </a>
            <div class="message-reactions" *ngIf="msg.reactions?.length">
              <button
                type="button"
                class="reaction-chip"
                *ngFor="let reaction of msg.reactions"
                [class.reacted]="reaction.reacted"
                (click)="addReaction(msg, reaction.emoji)"
              >
                <span>{{ reaction.emoji }}</span>
                <small>{{ reaction.count }}</small>
              </button>
            </div>
            <div class="message-actions">
              <button type="button" class="action-btn reaction-btn" (click)="toggleReactionPicker(msg)" title="Reagir">
                <mat-icon>sentiment_satisfied_alt</mat-icon>
              </button>
              <button type="button" class="action-btn reply-btn" (click)="setReplyTo(msg)" title="Responder">
                <mat-icon>reply</mat-icon>
              </button>
              <div class="reaction-picker" *ngIf="reactionPickerMessageId === msg.id">
                <button
                  type="button"
                  class="emoji-btn"
                  *ngFor="let emoji of emojiList"
                  (click)="addReaction(msg, emoji)"
                >
                  {{ emoji }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="chat-input" *ngIf="selectedConversation">
        <div class="chat-input-locked" *ngIf="isMessageBlocked">
          Somente administradores podem enviar mensagens neste grupo.
        </div>
        <div class="reply-composer" *ngIf="replyToMessage">
          <div class="reply-info">
            <strong>{{ replyToMessage.sender_name || 'Usuário' }}</strong>
            <span>{{ replyToMessage.message_text || (replyToMessage.file_name || 'Arquivo') }}</span>
          </div>
          <button type="button" class="reply-close" (click)="clearReply()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div
          class="input-shell"
          [class.dragging]="draggingMessage"
          (dragover)="onMessageDragOver($event)"
          (dragleave)="onMessageDragLeave($event)"
          (drop)="onMessageDrop($event)"
        >
          <div
            #messageInput
            class="message-editor"
            [class.disabled]="isMessageBlocked"
            [attr.contenteditable]="!isMessageBlocked"
            [attr.data-placeholder]="isMessageBlocked ? 'Envio bloqueado para membros' : 'Digite sua mensagem'"
            (keydown)="handleMessageKeydown($event)"
            (input)="onEditorInput()"
            (mouseup)="saveEditorSelection()"
            (keyup)="saveEditorSelection()"
            (focus)="saveEditorSelection()"
          ></div>
          <div class="drag-overlay" *ngIf="draggingMessage">
            Solte o arquivo para anexar
          </div>
          <div class="input-actions">
            <div class="action-group">
              <button type="button" class="emoji-toggle" (click)="toggleEmojiPicker()" title="Emojis">
                <mat-icon>sentiment_satisfied_alt</mat-icon>
              </button>
              <button
                type="button"
                class="emoji-toggle"
                *ngIf="!isRecording"
                (click)="startRecording()"
                title="Gravar áudio"
              >
                <mat-icon>mic</mat-icon>
              </button>
              <button
                type="button"
                class="emoji-toggle danger"
                *ngIf="isRecording"
                (click)="stopRecording()"
                title="Parar gravação"
              >
                <mat-icon>stop</mat-icon>
              </button>
              <label class="file-upload" title="Anexar arquivo">
                <input type="file" (change)="handleFileSelected($event)" [disabled]="isMessageBlocked">
                <mat-icon>attach_file</mat-icon>
              </label>
              <button type="button" class="send" (click)="sendMessage()" title="Enviar" [disabled]="isMessageBlocked">
                <mat-icon>send</mat-icon>
              </button>
            </div>
          </div>
          <div class="emoji-picker" *ngIf="showEmojiPicker" (click)="$event.stopPropagation()">
            <button
              type="button"
              class="emoji-btn"
              *ngFor="let emoji of emojiList"
              (click)="addEmojiToMessage(emoji)"
            >
              {{ emoji }}
            </button>
          </div>
        </div>
        <div class="recording-status" *ngIf="isRecording">
          <span class="dot"></span>
          Gravando {{ formatRecordingTime(recordingSeconds) }}
          <button type="button" (click)="cancelRecording()">Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</aside>

<div class="image-modal-backdrop" *ngIf="imageModalSrc" (click)="closeImageModal()"></div>
<div class="image-modal" *ngIf="imageModalSrc">
  <button type="button" class="image-modal-close" (click)="closeImageModal()">
    <mat-icon>close</mat-icon>
  </button>
  <img [src]="imageModalSrc" alt="Imagem ampliada">
</div>
